module.exports = __webpack_public_path__ + "images/412.gif";